import React, { Component } from 'react';
import { ApolloProvider } from 'react-apollo';
import {
  Site, AccountDropdown,
} from 'tabler-react';
import { Link } from '@curi/react-dom';
import client from './client';

import Router from './routes';


import { AuthProvider, AuthFunctions, IsLoggedIn } from './auth/Auth';

const LinkWrapper = props => <Link name={props.to} {...props} />;

const LOGGED_IN_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAE6UlEQVR4Xu2d7UsUURTG5/hvihSWJKKEIopYvqSZYooplphiiibKUkQhRRRSSLq6ri/r6rq67roVUUghhfTFiblz50X7vveBfT4tM8y+MHfOnnPPeX7nSCR/2xaxLbHOLbFsy7Jsq0Sc13NLnbdt9eocq/P6WF2vzttWiXqfvt5yPit0vXOsPid0vfqc0PX62P3e0Pfp31NUvy/yudV2bk6wCFbo5jnnLfdmqxvt3ET3OFgES593b7J/vb8I+npvkZ1Db3HV54ber847a+Itlv6+Ivp9Mp9vtd2bq59kWkpg+QYsWebz7bb/5BfRkwhryXPHd5QPCf6GaCkmfZ7M5TuVD/Edp/4Pp0/RgUqhfd5srtNmdONGhhDR4exxl+1GPcUd3aD4FHmau+f6kMv7Aj+0pU8ppE+RmVyPjrK8zRwtJdgUh/ZdhdpHTWd79E5d75D90LfId8yGfIpM53qVD+GOGSTjMJW970ZZzC1h5Oamsv06ygri7iBxyOir0NGXTB716526zvLSUoxaikxmB3wfwiwsQBZ74uiBG2WxXgFR75GJo6H/fAgtxaCljGeGLuSyaCmGK6PjR8O2uwis7CFURmUs89CGyHKyRq/K4jKWGXGjLNbAda3fsIZg9HAkyGVRLWJcbSOjmVGtOtFPBi3FrKWMHD7WqhPqqhB0aTJyOB7UQ6irUtFmEPoXXpcmjw7Gg1wWFYjGFZzy6GBCR1kg9YBiV0gOp58E2l5qdc0rOIcPptxclv93RUsxqnUeSk/pimFIXUJLMWYpMpSeDrS9tBTjCk4Z3J8JtL3kP4zzKTKYntUVQ/IfEArOgf1ZXTEkKeUpOI1qnQf25wJtL0mpEL5nRsEp/al5XTEkU+giGWYVnNK/H9EVw5C2l5ZizlL6UhFdMSR9i6DglL7UsyCX5UuBCp/lJJ+i61G9e8/JqSPp0npTL8ipX+LmTerSpGfvBTn1UAcJ07o06dl7SU4dSZfWvfuKnDqQ2ka69xbIqSPp0rqSCxcZQ9K3uhGPoS5GXbuvyakDqW3kbvINOXUgtY10Jt+SU/eE3giW0rHzlpw6kIZAOpLvyKnrTnk+fWzSUtp33pNT93pOIlhK+84iOXUgtY20JRbJqQOpbaRt5wM5daRuqy2Jj+TUgfoSS0tiiZw6kobg1vYSOXWkDt63Ep/IqXs9JwEsRZq3l8mpA/W6l+btKDl1JLVN01aUnDrQVAhp2l4jp+7lshAspXErRk4daH6KNG7FyakDTYWQhs04OXWg+SnSsLlJTt3LZSFYSv3GFjl1pPkp9ZsJcupI81PqNhLk1IGmw0ndRpKcOtD8FKmN75JTB5qjKLUbKXLqfgNOgF73N+MpcuoA9K0/R/JmPE1OHWh+itSsH5BTB5qfIjXxDDl1pNm81esZcuqeYhHAUqR6PUtOXfsQk/StP8mnKpYjp47EqVet58mpI3HqlbE8OXUkTr0y9oWcOhKnfmPtKzl1JE79RuwbOXUkTr1i9RvnqXu5LARLqVj7Tk7dJFN4qde9XF/94XPqRrtxco6i6iAh11ZPyKkjcerl0RNy6gj0ra17q5Sv/iSnjsSpX43+IqeOxKlfjZ6SU0fi1K+snJJTR+LUr0R/k1NH4tTLVv6QU0fi1MtWzsipA9C37qb83JLS5TNy6kiceunKX3LqQJz6P6ze62zIgtV2AAAAAElFTkSuQmCC';
const GUEST_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAFPElEQVR4Xu1d13bbMAw1/v8js/feO84RTsUorm3iGiIE0uhLm57QBngHQFBOaGdnZz6bzWbz+XxGRPx3/zX/49+f4f8v+z5kPfK6y94fWY/E5SEv2t3dna8KurZkSpDHGiQGZKiIAGG5UyD7gih4kUS0t7fHCllnW0gw1oxaJBOyGR7zYoVoN1G7HtnE1msKK6QF721FKQmQKOyJl3+6zDH2BXEA2t/fTzUklOKg9e8AkXRZHgvgKuYhjPSWFx0cHPzpsmpOpu8Way78bFkBgp9JBSukZkatOz/VmFcCZJ3ctecM7XpEwTWCMKzhdHh4uLbLQjbDW4GssaYwIK0cqoZ51KoUOjo6EnVZoRSbwp8UUiujcoPR2vJKCpFeToVSyiqFAWnBe1tRCh0fH2fvQ2qTvXQm5zEvVkjY1a8R55RWurVnhdTMqDEGjJ6UkgBBkI/CXq6w08nJCXwf4olRYzYkLvLqAJHch7gIVvjcGKJgb3nR6emp6KQehd+m8LNlWU5jkVplGZcXpbBCtMFo1wdIv3f5CRDrpysChOUPVNDZ2dlo9yGhFP1jqAyIpMtCGI10OcjrbkNNofPzc1GXhWxyKGVzpSSFSMcnCKMREJHXbVkpSSElzhmhFFwpDEhu/GDJyG1XCl1cXBS/DwmlyJXCCpHaVShl+fhkzFpJl5eX/3VZiG0gwYRS8kphy+prSChFPkAsRa6kEEs7KpXM1K37KHl1liU5qU+dLGKjNZOLrq6usl0WshlRU3SFny1LyyjtegREhByWcY1iV0QzVsjUdjRWMsNHeEqBjLzuJnklQMa4D7FkZKtKoevra/ipE2QzSjOqhoYEUkoHiCQpBIRQyuaFnW5ubkT3IZabDDFqyaNBXskjyYstC7EVr8l6jUsCwnBSkhTicWyCJrPYZdUIEgMyrCElWmBLu6sRhOH+0+3tbfakXgIkxCa3SSkMyGKXhWyWV0Z6jStHLrq7u1Pdh1jaUS6ZqT9ss+mkYJhXUkirydamlKQQLdO16xGbbJU8XV4MSK7LQjbLKyO9xrVILrq/v892WbUk03t4ia7QygFYIdJDYSgF+2whsl/997JCambUqqSRzfDkAAkQJKhak108b0mdwcquuKg/PDwUvQ+xTKaJ7qsDZFPmhFLGryn0+Phoch8SSvml77oTPVsWwvQmbMHxpRYrpNVNrjGvBAh6qKoxWUmtRLrNEjZMT09Po30Kd+pkkPdHbBp5XS1IDMgic5BgQyn5jxggs0J6fn4WdVkISJaMQuKqgTxJIdpgteu9gmgdV1KIdIyAMNI6GelMzjN5GBDE43LXpJ6T1dRKK3LRy8tL9j6k1U32mBcrpIRdeUx2ld16smF6fX1VPXXiKZkxnvrI2bf6nJEZ27Bl9UGEUpYPAEuDMCRBUoj2TUMp2Ch+5X53liWZ8Whrgna9VZeDzvTGjove3t6yXRbypqEUnVLYsiztKpSyfvbFCpGecEMp5X49ay+KBMiqzS4FQihlxU8lfX9/L/rUSdQUsKZ0gEi6rFBKebvqcKCPjw/RfYhl4UfAt4zLwmapV8jUhd0i2XUTCYQEJW04KUQ6NrFkJLJJlnGVJA8DUnqghjCqZLJT1kopuejz8zN7Up/azqTJtNC6s0I82tW2KoW+vr5U9yGW3r0NSmHLQu9DLEHYNqUkhWg3WbseKfxNK6WzLEn3MXVh3xal0Pf3d7bL8spIr3FpyMOWpbUb7XrErjTJeq6VPblYISXsyBKklpSSABnjUGUJQqtKoa6ATH2xv+79ETtrQSk/hUIYghpE+h4AAAAASUVORK5CYII=';

class App extends Component {
  wrapper = null;

  authOptions({ isLoggedIn, logout }) {
    if (isLoggedIn) {
      return [
        { icon: 'user', value: 'Profile', to: 'Profile' },
        { icon: 'log-out', value: 'Sign out', onClick: logout },
      ];
    }
    return [
      {
        icon: 'log-in', value: 'Login', to: 'Login', RootComponent: LinkWrapper,
      },
      {
        icon: 'book-open', value: 'Register', to: 'Register', RootComponent: LinkWrapper,
      },
    ];
  }

  render() {
    return (
      <ApolloProvider client={client}>
        <AuthProvider>
          <Router>
            {({ response }) => {
              const { body: Body } = response;
              return (
                <IsLoggedIn>
                  {isLoggedIn => (
                    <AuthFunctions>
                      {({ logout }) => (
                        <Site.Wrapper
                          ref={ref => this.wrapper = ref}
                          headerProps={{
                            children: (
                              <React.Fragment>
                                <Site.Logo href="/" alt="BidFTA Toolkit" src={require('./components/FtaKitWordLogo.png')} />
                                <div className="d-flex order-lg-2 ml-auto">
                                  <AccountDropdown
                                    avatarURL={isLoggedIn ? LOGGED_IN_IMAGE : GUEST_IMAGE}
                                    name={isLoggedIn ? 'Bidder' : 'Guest'}
                                    description={isLoggedIn ? 'Logged in' : 'Login'}
                                    options={this.authOptions({ isLoggedIn, logout })}
                                  />
                                </div>
                                <a
                                  className="header-toggler d-lg-none ml-3 ml-lg-0"
                                  onClick={() => this.wrapper.handleCollapseMobileMenu()}
                                >
                                  <span className="header-toggler-icon" />
                                </a>
                              </React.Fragment>
                            ),
                          }}
                          navProps={{
                            itemsObjects: [
                              {
                                value: 'Home',
                                to: 'Home',
                                icon: 'home',
                                LinkComponent: LinkWrapper,
                                useExact: true,
                              },
                              {
                                value: 'Search',
                                to: 'Search',
                                icon: 'search',
                                LinkComponent: LinkWrapper,
                              },
                              {
                                value: isLoggedIn ? 'Manage My Alert Keywords' : 'Sign up for Keyword Alerts',
                                to: isLoggedIn ? 'Keywords' : 'Register',
                                icon: 'search',
                                LinkComponent: LinkWrapper,
                              },
                              {
                                value: 'Advanced Search',
                                to: 'Archive',
                                icon: 'database',
                                LinkComponent: LinkWrapper,
                              },
                              {
                                value: 'Scan',
                                to: 'Scan',
                                icon: 'package',
                                LinkComponent: LinkWrapper,
                              },
                              {
                                value: 'News and Updates',
                                to: 'Updates',
                                icon: 'book-open',
                                LinkComponent: LinkWrapper,
                              },
                            ],
                          }}
                        >
                          <Body response={response} />
                        </Site.Wrapper>
                      )}
                    </AuthFunctions>
                  )}
                </IsLoggedIn>
              );
            }}
          </Router>
        </AuthProvider>
      </ApolloProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js